export default __webpack_public_path__ + "static/media/img_rentcar_01_sp.64083b13.png";